import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import { useForm } from 'react-final-form';
import CheckIcon from 'mdi-react/CheckIcon';
import TextAreaField from '../../../shared/components/form/TextAreaField';
import Collapse from '../../../shared/components/Collapse';

const ObjectivesTab = ({ t, objectives, curriculum }) => {
  const [objectivesByCourse, setObjectivesByCourse] = useState([]);
  const form = useForm();

  const objectiveChange = (field, evt, index) => {
    if (evt) {
      const updatedSubjects = [...objectivesByCourse];
      const subject = updatedSubjects[index];
      subject[field] = evt.target.value;
      updatedSubjects[index] = {
        ...subject,
      };
      setObjectivesByCourse(updatedSubjects);
    }
  };

  useEffect(() => {
    const mapOfSubject = new Map();
    curriculum.forEach((currItem) => {
      mapOfSubject.set(currItem.subject.id, currItem.subject);
    });

    const updatedObjectives = objectives.filter((obj) =>
      mapOfSubject.get(obj.subject.id)
    );
    if (mapOfSubject.size > objectives.length) {
      mapOfSubject.forEach((subject) => {
        if (
          objectives.findIndex((obj) => obj.subject.id === subject.id) === -1
        ) {
          updatedObjectives.push({
            id: 0,
            subject: { ...subject },
            general: '',
            specific: '',
          });
        }
      });
    }
    setObjectivesByCourse(updatedObjectives);
  }, []);

  useEffect(() => {
    form.change('objectives', objectivesByCourse);
  }, [objectivesByCourse]);

  return (
    <div className="form">
      {objectivesByCourse.length ? (
        objectivesByCourse.map((objective, index) => (
          <div key={objective.subject.name} className="form__form-group">
            <Collapse
              className="with-check-icon"
              title={
                <span>
                  {objective.subject.name}
                  <span>
                    <CheckIcon
                      className={objective.general.length && 'check'}
                    />
                    <CheckIcon
                      className={objective.specific.length && 'check'}
                    />
                  </span>
                </span>
              }
            >
              <div className="form__form-group--2_columns">
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('general.general-objective')}
                  </span>
                  <div className="form__form-group-field">
                    <TextAreaField
                      name="generalObjective"
                      input={{
                        value: objective.general,
                        onChange: (evt) =>
                          objectiveChange('general', evt, index),
                      }}
                      placeholder={t('placeholder.course.describe-here')}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('general.specific-objective')}
                  </span>
                  <div className="form__form-group-field">
                    <TextAreaField
                      name="specificObjective"
                      input={{
                        value: objective.specific,
                        onChange: (evt) =>
                          objectiveChange('specific', evt, index),
                      }}
                      placeholder={t('placeholder.course.describe-here')}
                    />
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        ))
      ) : (
        <Alert className="alert-notification w-100 text-center" color="info">
          {t('general.register-curriculum')}
        </Alert>
      )}
    </div>
  );
};

ObjectivesTab.propTypes = {
  t: PropTypes.func.isRequired,
  objectives: PropTypes.arrayOf(PropTypes.shape),
  curriculum: PropTypes.arrayOf(PropTypes.shape),
};

ObjectivesTab.defaultProps = {
  objectives: [],
  curriculum: [],
};

export default withTranslation('common')(ObjectivesTab);
